module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-02.d513dce6.png";